import * as React from 'react';
import uniq = require('lodash/uniq');

import ClearAllView from 'filter-clear-all.view';
import { removeAllEventFilters, goToMonth } from '../../redux-state/actions/calendar.actions';
import { ICalendarAppState } from '../../redux-state';
import { connect } from 'react-redux';
import { ICalendarAppText } from '../../custom/classes/calendar-text';
import moment = require('moment');


interface IFilterExternalProps {
}

interface StateToProps {
    text: ICalendarAppText;
}

interface DispatchToProps {
    removeAllFilters: () => void;
}

export type ClearAllProps = IFilterExternalProps & StateToProps & DispatchToProps;

export class ClearAllBase extends React.Component<ClearAllProps, null> {
    render() {
        return <ClearAllView {...this.props} />;
    }
}

function mapStateToProps(state: ICalendarAppState, ownProps: IFilterExternalProps): StateToProps {
    return {
        text: state.calendarText
    }
}

function mapDispatchToProps(dispatch): DispatchToProps {
    return {
        removeAllFilters: () => {
            dispatch(removeAllEventFilters());
            dispatch(goToMonth(moment()));
        }
    }
}

export default connect<StateToProps, DispatchToProps>(mapStateToProps, mapDispatchToProps)(ClearAllBase);